/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from "react";
import "./style.less";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import logo from "@/assets/at_logo.png";
import useWindowScrollHeight from "@/hooks/useWindowScrollHeight";
import { AiOutlineDown } from "react-icons/ai";
import { Animated } from "react-animated-css";
const NavBar = (props) => {
  const getScrollHeight = useWindowScrollHeight();
  const location = useLocation();
  const pathName = location?.pathname;

  useEffect(() => {
  }, []);
  const { list } = props;
  const navList = [
    { path: "/", key: "/", name: "Home" },
    { path: "product", key: "product", name: "Products & Services" },
    { path: "/industries", key: "Solutions", name: "Industries & Advantages" },
    { path: "/contact", key: "AboutUs", name: "About Us&Contact Us" },
  ];

  const NavClick = (path, event) => {
    console.log(path);
    if (!path) {
      event.preventDefault();
    }
  };
  return (
    <>
      <div className="advertising_tip">
        <div className="middle">
          To be a leading provider of computing infrastructure for the AI and
          blockchain revolution.
        </div>
      </div>
      <div
        className={`nav_bar ${getScrollHeight > 0 ? "window_scroll" : ""}`}
        style={{ top: getScrollHeight < 40 ? 40 - getScrollHeight : 0 }}
      >
        <div className="nav_warp">
          <div className="logo">
            <Link to={"/"}>
              <img src={logo} />
            </Link>
          </div>
          <div className="nav_list">
            {navList.map((val, index) => {
              return (
                <div className="nav_item">
                  <div className="nav_item_content">
                    <Link
                      to={val.path}
                      className={`${
                        (pathName !== "/" &&
                          val.key !== "/" &&
                          pathName.indexOf(val.key) != -1) ||
                        (pathName === "/" && val.key == "/")
                          ? "active"
                          : ""
                      }`}
                      to={val.path}
                    >
                      {val.name}
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>
          {/* <div className="special"><Link to={'/contact'}>Contact Us</Link></div> */}
        </div>
      </div>
    </>
  );
};

export default NavBar;
